<template>
  <section id="user-config" class="page-content">
      <header id="section-header">
          <p class="title has-text-grey">User Config</p>
          <p class="subtitle has-text-grey">Edit your user information.</p>
      </header>
      <main id="section-body">
        <div>
          <div class="separator">
            <label class="separator-title">Personal Info</label>
            <div class="field field-inline">
              <label class="label">Username</label>
              <div class="control">
                <input class="input" type="text" v-model="user.username" name="username" id="username" disabled>
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Email</label>
              <div class="control">
                <input class="input" type="text" v-model="user.email" name="email" id="email" disabled>
              </div>
            </div>
            <br/>
            <div class="field field-inline">
              <label class="label">First Name</label>
              <div class="control">
                <input class="input" type="text" v-model="user.first_name" name="firstname" id="firstname">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Last Name</label>
              <div class="control">
                <input class="input" type="text" v-model="user.last_name" name="lastname" id="lastname">
              </div>
            </div>
          </div>
          <div class="separator">
            <label class="separator-title">Email Alert Configuration</label>
            <div class="field field-inline">
              <label class="label">ETD at POL or ETA at POD delay >=</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_days_of_delay" name="email_report_days_of_delay" id="email_report_days_of_delay">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">ETD at POL or ETA at POD advance >=</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_days_in_advance" name="email_report_days_in_advance" id="email_report_days_in_advance">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max days in TSP</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_days_in_tsp" name="email_report_max_days_in_tsp" id="email_report_max_days_in_tsp">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max days in TSP Planned</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_days_in_tsp_planned" name="email_report_max_days_in_tsp_planned" id="email_report_max_days_in_tsp_planned">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max days in POL</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_days_in_pol" name="email_report_max_days_in_pol" id="email_report_max_days_in_pol">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max days in POL Planned</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_days_in_pol_planned" name="email_report_max_days_in_pol_planned" id="email_report_max_days_in_pol_planned">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max storage days at POL</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_storage_days_at_pol" name="email_report_max_storage_days_at_pol" id="email_report_max_storage_days_at_pol">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max storage days at POL Planned</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_storage_days_at_pol_planned" name="email_report_max_storage_days_at_pol_planned" id="email_report_max_storage_days_at_pol_planned">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max days in POD</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_days_in_pod" name="email_report_max_days_in_pod" id="email_report_max_days_in_pod">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max days in POD Planned</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_days_in_pod_planned" name="email_report_max_days_in_pod_planned" id="email_report_max_days_in_pod_planned">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max storage days at POD</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_storage_days_at_pod" name="email_report_max_storage_days_at_pod" id="email_report_max_storage_days_at_pod">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max storage days at POD Planned</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_storage_days_at_pod_planned" name="email_report_max_storage_days_at_pod_planned" id="email_report_max_storage_days_at_pod_planned">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max days between Empty Return and POD</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_days_between_empty_return_and_pod" name="email_report_max_days_between_empty_return_and_pod" id="email_report_max_days_between_empty_return_and_pod">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max days between Empty Return and POD Planned</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_days_between_empty_return_and_pod_planned" name="email_report_max_days_between_empty_return_and_pod_planned" id="email_report_max_days_between_empty_return_and_pod_planned">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max days between Empty Return and LIF</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_days_between_empty_return_and_lif" name="email_report_max_days_between_empty_return_and_lif" id="email_report_max_days_between_empty_return_and_lif">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Max days between Empty Return and LIF Planned</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_days_between_empty_return_and_lif_planned" name="email_report_max_days_between_empty_return_and_lif_planned" id="email_report_max_days_between_empty_return_and_lif_planned">
              </div>
            </div>
            <div class="field field-inline">
              <label class="label">Contractual ETA at POD discrepancy days</label>
              <div class="control">
                <input class="input" type="number" v-model.number="user.userprofile.email_report_max_days_eta_pod_discrepancy" name="email_report_max_days_eta_pod_discrepancy" id="email_report_max_days_eta_pod_discrepancy">
              </div>
            </div>
            <div class="field field-inline">
             <label class="label">Contractual ETA at DLV discrepancy days</label>
             <div class="control">
               <input class="input" type="number" v-model.number="user.userprofile.email_report_max_days_eta_dlv_discrepancy" name="email_report_max_days_eta_dlv_discrepancy" id="email_report_max_days_eta_dlv_discrepancy">
             </div>
            </div>
            <div class="field field-inline">
              <label class="label">POD Time of arrival warning risk</label>
              <div class="control">
                <div class="select">
                  <select placeholder="Choose Risk" v-model="user.userprofile.email_pod_timeofarrival_warning_risk">
                    <option :value="null">------</option>
                    <option v-for="risk in podTimeOfArrivalWarningRisk" :key="risk.value" :value="risk.value">{{ risk.label }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="field">
                <label class="label">Attention Required event Codes</label>
                <div class="event-code-container" style="max-height:215px; overflow-y: auto">
                    <ul style="column-count:3">
                    <li v-for="eventCode in eventCodes" :key="eventCode.code" >
                        <label class="checkBox" :for="eventCode.code" v-on:click.capture.stop>
                            <input type="checkbox" :id="eventCode.code" :value='eventCode.code' v-model="user.userprofile.email_report_attention_required_event_codes">
                            <span class="checkmark"/>
                            {{eventCode.description}}
                        </label>
                    </li>
                    </ul>
                </div>
            </div>
          </div>
          <div class="field">
            <label class="label">Report Emails</label>
            <div class="control">
                <tag-input placeholder="Report Emails" :checkFormat="false" @updated="user.userprofile.report_emails=$event" :inputTags="user.userprofile.report_emails" ></tag-input>
            </div>
          </div>
        </div>
        <div class="field" style="padding:1em 0;">
            <a class="button is-primary" @click="save()">Save</a>
            <router-link :to="{ name: 'dashboard'}" class="button">Back</router-link>
        </div>
      </main>
  </section>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import TagInput from '@/components/TagInput'

export default {
  name: 'user-config',
  components: {TagInput},
  mounted () {
    this.$emit('loading')
    const promises = [
      this.getEventCodes().then(response => { this.eventCodes = response }),
      this.getUserInfo().then(response => {
        this.user = response
        if (!this.user.userprofile.email_report_attention_required_event_codes) this.user.userprofile.email_report_attention_required_event_codes = []
      })
    ]
    Promise.all(promises).then(data => { this.$emit('loaded') })
  },
  data () {
    return {
      user: {userprofile: {email_report_attention_required_event_codes: []}},
      eventCodes: [],
      podTimeOfArrivalWarningRisk: [
//        {'label': 'Unknown', 'value': -1},
//        {'label': 'No Risk', 'value': 0},
        {'label': 'Low', 'value': 1},
        {'label': 'High', 'value': 2}
      ]
    }
  },
  computed: {
    ...mapGetters({hasPermission: 'hasPermission'})
  },
  methods: {
    ...mapActions({
      getEventCodes: 'eventCode/list',
      getUserInfo: 'user/readUserConfig',
      saveUser: 'user/saveUserConfig'
    }),
    save () {
      var user = JSON.parse(JSON.stringify(this.user))

      if (!user.userprofile.email_report_days_of_delay) {
        user.userprofile.email_report_days_of_delay = null
      }

      if (!user.userprofile.email_report_days_in_advance) {
        user.userprofile.email_report_days_in_advance = null
      }

      if (!user.userprofile.email_report_max_days_in_tsp) {
        user.userprofile.email_report_max_days_in_tsp = null
      }

      if (!user.userprofile.email_report_max_days_in_pol) {
        user.userprofile.email_report_max_days_in_pol = null
      }

      if (!user.userprofile.email_report_max_days_in_pod) {
        user.userprofile.email_report_max_days_in_pod = null
      }

      if (!user.userprofile.email_report_max_storage_days_at_pol) {
        user.userprofile.email_report_max_storage_days_at_pol = null
      }

      if (!user.userprofile.email_report_max_storage_days_at_pod) {
        user.userprofile.email_report_max_storage_days_at_pod = null
      }

      if (!user.userprofile.email_report_max_days_between_empty_return_and_pod) {
        user.userprofile.email_report_max_days_between_empty_return_and_pod = null
      }

      if (!user.userprofile.email_report_max_days_between_empty_return_and_lif) {
        user.userprofile.email_report_max_days_between_empty_return_and_lif = null
      }

      if (!user.userprofile.email_report_max_days_in_pol_planned) {
        user.userprofile.email_report_max_days_in_pol_planned = null
      }

      if (!user.userprofile.email_report_max_days_in_pod_planned) {
        user.userprofile.email_report_max_days_in_pod_planned = null
      }

      if (!user.userprofile.email_report_max_days_in_tsp_planned) {
        user.userprofile.email_report_max_days_in_tsp_planned = null
      }

      if (!user.userprofile.email_report_max_storage_days_at_pol_planned) {
        user.userprofile.email_report_max_storage_days_at_pol_planned = null
      }

      if (!user.userprofile.email_report_max_storage_days_at_pod_planned) {
        user.userprofile.email_report_max_storage_days_at_pod_planned = null
      }

      if (!user.userprofile.email_report_max_days_between_empty_return_and_pod_planned) {
        user.userprofile.email_report_max_days_between_empty_return_and_pod_planned = null
      }

      if (!user.userprofile.email_report_max_days_between_empty_return_and_lif_planned) {
        user.userprofile.email_report_max_days_between_empty_return_and_lif_planned = null
      }

      if (!user.userprofile.email_report_max_days_eta_dlv_discrepancy) {
        user.userprofile.email_report_max_days_eta_dlv_discrepancy = null
      }

      if (!user.userprofile.email_report_max_days_eta_pod_discrepancy) {
        user.userprofile.email_report_max_days_eta_pod_discrepancy = null
      }

      user.userprofile.is_manager = undefined

      this.saveUser(user).then(response => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/PageUserConfig.vue